import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltCommentDialogVisibilityDropdownTriggerLabelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-visibility-dropdown-trigger-label-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentDialogVisibilityDropdownTriggerLabelWireframe;
